import React, { Component } from 'react'
import { connect } from 'react-redux'

import TextField from 'material-ui/TextField'
import Divider from 'material-ui/Divider'

import StatusSelect from './StatusSelect'
import OwnerCombobox from 'components/OwnerCombobox'
import AgentCombobox from 'components/AgentCombobox'
import Facts from './Facts'
import Vendors from './vendors'
import LastLease from './LastLease'
import ExternalLinks from './ExternalLinks'
import Transactions from './transactions'
import Projects from './projects'

import { propertyAlias } from 'utils/propertyAlias'
import { propertyCors } from 'utils/propertyCors'
import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		let address = props.property.address || ""
		return(
			<div
				key={props.property.alias}
				className="left-side"
				style={{
					 width: (this.props.colspan>1)?"50%":"100%"
   				   , overflowY: (this.props.colspan>1)?"scroll":"hidden"
				   , overflowX: "hidden"
				}}
			>
				<div style={{width: "100%", padding:"0 30px 10px 20px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", background:"white"}}>
					<TextField
						hintText = "Enter address"
						hintStyle={{fontStyle: "italic", fontSize: "16px", top:"13px"}}
						underlineStyle={{
							borderBottom: "0px solid #b0bec4"
						}}
						multiLine = {true}
						style={{
							width: "100%"
						  , position: "relative"
						  , height: "45px"
						  , paddingLeft: "40px"
						}}
						inputStyle={{
							fontSize: "16px"
						  , fontWeight: "bold"
						}}
						defaultValue={address}
						onBlur={(evt) =>{
							//let cors = propertyCors(evt.target.value)
							props.STAGE({
								_id: props.propertyID
								, address: evt.target.value.replace(/[\r\n\t\v]/g, " ")
								, alias: props.property.alias || propertyAlias(evt.target.value)
								, cors: {}
							})
						}}
					/>
					<TextField
						hintText = {(address)?"Enter address":"Waiting for address input"}
						hintStyle={{fontStyle: "italic", fontSize: "16px", top:"13px"}}
						underlineStyle={{
							borderBottom: "0px solid #b0bec4"
						}}
						multiLine = {false}
						style={{
							width: "100%"
						  , marginTop: "-10px"
						  , position: "relative"
						  , paddingLeft: "38px"
						  , height: "45px"
						}}
						inputStyle={{
							fontSize: "16px"
						  , fontWeight: "bold"
						}}
						defaultValue={props.property.alias}
						onBlur={(evt) =>{
							props.STAGE({
								_id: props.propertyID
							  , alias: evt.target.value
							})
						}}
					/>
					<OwnerCombobox objectID={props.propertyID} />
					<AgentCombobox objectID={props.propertyID} />
					<StatusSelect propertyID={props.propertyID} />
					{!props.property.dateTill && <LastLease propertyID={props.propertyID} />}
					<ExternalLinks propertyID={props.propertyID} />
				</div>
				<Facts propertyID={this.props.propertyID} />
				<Projects propertyID={this.props.propertyID} />
				<Vendors propertyID={this.props.propertyID} />
				<Transactions propertyID={this.props.propertyID} />
			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/LeftSide.js